module.exports = __webpack_public_path__ + "assets/51c64f4bae03ae4bd19d06bf042c9e24.svg";